<template>
<div class='vx-col w-full mt-4 mb-4'>
    <vx-card v-if="es_hoy">
        <div class="card">
            <img :src="require('@/assets/images/birthday/'+num_imagen+'.svg')" alt="birthday" class="birthday">
        </div>
        <div id="container">
            <div class="balloons">
                <div v-for="(div, index) in 20" :key="index"> {{ }}</div>
            </div>
        </div>
        <transition name="ease-in-out">
            <div class="card-mensaje">
                <div class="titulo-nombre text-right"> {{usuario.nombre}}</div>
                <div class="texto text-right">
                    <div>{{ mensajes[mensaje_birth].message }}</div>
                </div>
            </div>
        </transition>
        <div class="mb-4"></div>
    </vx-card>
</div>
</template>

<script>
import moment from 'moment';
export default {
    components: {},
    data() {
        return {
            usuario: '',
            es_hoy: '',
            num_imagen: 1,
            no_birthday: false,
            mensajes: [{
                id: 1,
                message: 'Feliz cumpleaños, deseamos que tu vida siga floreciendo y sigas avanzando. ¡Felicidades - Equipo AZ!'
            }, {
                id: 2,
                message: 'Estamos felices de que cumplas un año más y esperamos seguir estando a tu lado para celebrar los que se vienen. ¡Feliz cumpleaños - Equipo AZ.'
            }, {
                id: 3,
                message: ' Este nuevo cumpleaños es una nueva oportunidad de realizar tus sueños y seguir luchando por lo que quieres. ¡Feliz cumpleaños - Equipo AZ!'
            }, {
                id: 4,
                message: 'Felicidades por este año más de vida, por este nuevo comienzo y por los nuevos retos que te esperan ¡Equipo AZ!'
            }, {
                id: 5,
                message: 'Deseamos que a pesar del paso de los años continúes teniendo esa alegría, carisma y bondad que te caracterizan. Feliz cumpleaños. ¡Equipo AZ!'
            }, {
                id: 6,
                message: 'Que este día comience lleno de alegría y buenos deseos. Feliz cumpleaños, te lo mereces por ser una persona tan especial. ¡Felicidades - Equipo AZ!'
            }, {
                id: 7,
                message: 'Un año más de vida es para celebrar y agradecer a Dios por esta gran bendición. Que más que regalos y torta, recibas mucha paz y felicidad. ¡Equipo AZ!'
            }]
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.f_inicio();
    },
    methods: {
        f_inicio() {
            let me = this;
            me.num_imagen = Math.ceil(Math.random() * 4)
            me.mensaje_birth = Math.ceil(Math.random() * me.mensajes.length)
            me.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
            // console.log('RANDOM IMAGE ', me.num_imagen)
            // console.log('CUMPLEAÑOS', me.usuario.f_nacimiento)
            if (me.usuario.f_nacimiento === undefined || me.usuario.f_nacimiento === null) {
                me.no_birthday = true;
            } else {
                me.no_birthday = false;
                me.f_verifica_nacimiento();
            }
        },
        f_verifica_nacimiento() {
            const today = moment();
            const fechaHoy = today.format("MM-DD");
            const birth = this.usuario.f_nacimiento;
            const fechaNacimiento = birth.substring(5, 10);
            // console.log('fechaHoy',fechaHoy, fechaNacimiento);
            if (fechaHoy === fechaNacimiento) {
                this.es_hoy = true;
            } else {
                this.es_hoy = false;
            }
        }
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poetsen+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100..700;1,100..700&family=Poetsen+One&display=swap');


* {
    transition: all 0.2s ease-in-out;
}

@media only screen and (min-width: 1000px) {
    .card {
        flex-direction: row-reverse;
    }

    .card img.birthday {
        width: 100%;
        max-width: 100vw;
        max-height: unset;
    }
}

@media only screen and (max-height: 640px) {
    .card {
        flex-direction: row-reverse;
    }

    .card img.birthday {
        width: 100%;
        /* max-width: 50vw; */
        max-height: unset;
    }

}
@media only screen and (max-width: 640px) {
    .titulo-nombre {
        font-family: "Poetsen One", sans-serif;
        font-weight: 300;
        font-style: normal;
        font-size: 1.2em;
        /* color: red; */
    }

    .texto {
        font-family: "Josefin Sans", sans-serif;
        font-optical-sizing: auto;
        font-weight: 200;
        font-style: normal;
        font-size: 1em;
        /* color: red; */
    }
}

img.birthday {
    max-height: 40vh;
}

.text {
    padding: 1em;
}

.muted {
    opacity: 0.8;
}

#container {
    /* position: relative; */
    /* height: 100px; */
    margin: -300;
    padding: 0;
    /* background: #87ceeb; */
    overflow: hidden;
    z-index: 999;
}

.balloons div {
    position: absolute;
    left: 0;
    bottom: -150px;
    width: 50px;
    height: 60px;
    background: #ffa07a;
    border-radius: 50%;
    box-shadow: -6px -6px 0 rgba(0, 0, 0, 0.15) inset;
}

.balloons div:before {
    content: '';
    position: absolute;
    left: 22px;
    bottom: -48px;
    width: 2px;
    height: 50px;
    background: #a0a0a0;
    transform: rotate(5deg);
}

.balloons div:nth-of-type(1) {
    left: -5%;
    background: #9400d3;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 13s ease-in-out infinite;
}

.balloons div:nth-of-type(2) {
    left: 12%;
    background: #ffc0cb;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 7s ease-in-out infinite;
}

.balloons div:nth-of-type(3) {
    left: 18%;
    background: #ffa07a;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 16s ease-in-out infinite;
}

.balloons div:nth-of-type(4) {
    left: 22%;
    background: #f0f8ff;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 14s ease-in-out infinite;
}

.balloons div:nth-of-type(5) {
    left: 36%;
    background: #ffa07a;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 7s ease-in-out infinite;
}

.balloons div:nth-of-type(6) {
    left: 50%;
    background: #00fa9a;
    animation: wobbling_x 0.9s ease-in-out infinite alternate,
        wobbling_y 1.2s ease-in-out infinite alternate,
        fly_high 12s ease-in-out infinite;
}

.balloons div:nth-of-type(7) {
    left: 62%;
    background: #ffc0cb;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 15s ease-in-out infinite;
}

.balloons div:nth-of-type(8) {
    left: 68%;
    background: #9400d3;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 7s ease-in-out infinite;
}

.balloons div:nth-of-type(9) {
    left: 78%;
    background: #ffa07a;
    animation: wobbling_x 0.9s ease-in-out infinite alternate,
        wobbling_y 1.2s ease-in-out infinite alternate,
        fly_high 9s ease-in-out infinite;
}

.balloons div:nth-of-type(10) {
    left: 90%;
    background: #ff0000;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 11s ease-in-out infinite;
}

.balloons div:nth-of-type(11) {
    left: 0%;
    background: #f0f8ff;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 9s ease-in-out infinite 7s;
}

.balloons div:nth-of-type(12) {
    left: 3%;
    background: #ffa07a;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 7s ease-in-out infinite 2s;
}

.balloons div:nth-of-type(13) {
    left: 10%;
    background: #ff0000;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 8s ease-in-out infinite 5s;
}

.balloons div:nth-of-type(14) {
    left: 25%;
    background: #00ced1;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 12s ease-in-out infinite 6s;
}

.balloons div:nth-of-type(15) {
    left: 37%;
    background: #00fa9a;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 7s ease-in-out infinite 4s;
}

.balloons div:nth-of-type(16) {
    left: 45%;
    background: #00ced1;
    animation: wobbling_x 0.9s ease-in-out infinite alternate,
        wobbling_y 1.2s ease-in-out infinite alternate,
        fly_high 9s ease-in-out infinite;
}

.balloons div:nth-of-type(17) {
    left: 55%;
    background: #ffc0cb;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 13s ease-in-out infinite 8s;
}

.balloons div:nth-of-type(18) {
    left: 60%;
    background: #f0f8ff;
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 10s ease-in-out infinite 1s;
}

.balloons div:nth-of-type(19) {
    left: 75%;
    background: #00fa9a;
    animation: wobbling_x 0.9s ease-in-out infinite alternate,
        wobbling_y 1.2s ease-in-out infinite alternate,
        fly_high 15s ease-in-out infinite 7s;
}

.balloons div:nth-of-type(20) {
    left: 95%;
    /* background: #00ced1; */
    animation: wobbling_x 0.8s ease-in-out infinite alternate,
        wobbling_y 1.1s ease-in-out infinite alternate,
        fly_high 11s ease-in-out infinite 6s;
}

@keyframes wobbling_x {
    0% {
        margin-left: 8px;
    }

    100% {
        margin-left: 0px;
    }
}

@keyframes wobbling_y {
    0% {
        margin-bottom: 0px;
    }

    100% {
        margin-bottom: 8px;
    }
}

@keyframes fly_high {
    100% {
        transform: translateY(-1000px);
    }
}


.card-mensaje {
    margin-top: -80px;
    font-family: 'Swap';
    padding: 15px;
    background-color: white;
    border-radius: 10px;
    z-index: 5000;
    position: absolute;
    width: 90%;
    right: 5%;
    left: 5%;
    box-shadow: 4px 4px 8px 1px rgba(0, 0, 0, 0.2);
}

.titulo-nombre {
    font-family: "Poetsen One", sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 1.8em;
}

.texto {
    font-family: "Josefin Sans", sans-serif;
    font-optical-sizing: auto;
    font-weight: 500;
    font-style: normal;
    font-size: 1.4em;
}
</style>
